import React from "react";
import { BaseCard, SVGIcon } from "../baseCard/baseCard.tsx";
import {
    getFontSizes,
    getTitleHeight,
    darkenColor,
} from "../baseCard/BaseCardUtils.ts";
import "./LineDotCard.css";

interface LineDotCardProps {
    category: string;
    title: string;
    Data: {
        label: string;
        value: number;
    }[];
    score: number; // 1-5
    highlight?: boolean;
}

const LineDotCard: React.FC<LineDotCardProps> = ({
    category,
    title,
    Data,
    score,
    highlight = false,
}) => {
    const fontSizes = getFontSizes(highlight);
    const titleHeight = getTitleHeight(highlight);
    const color = "var(--color-light-gray)";
    const shapeColor = darkenColor(color);

    const renderDots = (score: number) => {
        const dots = [];
        for (let i = 1; i <= 5; i++) {
            dots.push(
                <div
                    key={i}
                    className={`LineDotCard-dot ${i <= score ? "LineDotCard-dot-filled" : ""}`}
                />
            );
        }
        return dots;
    };

    const svgPaths = {
        topShape:
            "M20.7637 1.11044e-05C9.71799 1.24175e-05 0.76368 8.95433 0.763673 20L0.763678 97.4131C9.37694 104.498 32.5399 112.037 67.7002 90.1162C103.94 67.5225 112.736 17.7127 114.172 0L20.7637 1.11044e-05Z",
        bottomShape:
            "M206.493 109.598C206.493 120.643 197.539 129.598 186.493 129.598H0.626953C8.79625 105.382 42.9206 56.9502 114.063 56.9502C185.206 56.9502 205.326 19.2817 206.493 0.447266V109.598Z",
    };

    return (
        <BaseCard highlight={highlight} color={color} className="LineDotCard-card">
            <SVGIcon
                className="baseCard-icon-top-right"
                viewBox="0 0 115 105"
                fillColor={shapeColor}
                path={svgPaths.topShape}
            />

            <SVGIcon
                className="baseCard-icon-bottom-left"
                viewBox="0 0 207 130"
                fillColor={shapeColor}
                path={svgPaths.bottomShape}
            />

            <div className="baseCard-content LineDotCard-content">
                <div className="LineDotCard-header">
                    <div
                        className="LineDotCard-category"
                        style={{ fontSize: fontSizes.category }}
                    >
                        {category.toUpperCase()}
                    </div>

                    <div
                        className="LineDotCard-title"
                        style={{
                            fontSize: fontSizes.title,
                            height: titleHeight,
                        }}
                    >
                        {title}
                    </div>

                    <div
                        className="baseCard-divider LineDotCard-divider"
                        style={{
                            width: "calc(100% + 2 * var(--spacing-3))",
                        }}
                    ></div>
                </div>
                {Data.map((item, index) => (
                    <div key={index} className="LineDotCard-main-content">
                        <div
                            className="LineDotCard-subtitle1"
                            style={{ fontSize: fontSizes.listItem }}
                        >
                            {item.label}
                        </div>

                        <div className="LineDotCard-dots-container">{renderDots(item.value)}</div>
                        {(index == Data.length - 1) ? <></> : <div className="LineDotCard-thin-divider"></div>}

                    </div>

                ))}

            </div>
        </BaseCard>
    );
};

export default LineDotCard;
